module.exports = __webpack_public_path__ + "img/icon-send.dab1cf29.svg";